import { matchPath } from 'react-router-dom';

const getRouteForIndex = (routes: string[], index: number) => routes[index];

const getIndexForRoute = (routes: string[], route: string): number => {
  let currentIndex = -1;

  for (let i = 0, l = routes.length; i < l; i += 1) {
    if (matchPath(routes[i], route)) {
      currentIndex = i;
      break;
    }
  }
  return currentIndex;
};

export const getPageByIndex = (
  routes: string[],
  currentRoute: string,
  getNextPosition: (currentPosition: number) => number,
): string => {
  const currentPosition = getIndexForRoute(routes, currentRoute);
  if (currentRoute === '' || currentPosition === -1) {
    return '/';
  }
  return getRouteForIndex(routes, getNextPosition(currentPosition));
};
